/**
 * UUID generation utilities
 * 
 * This file provides consistent UUID generation functions that can be used
 * throughout the application to ensure we always use the same implementation.
 */

/**
 * Generate a UUID v4 string
 * @returns A UUID v4 string in the format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Generate a simple unique ID (shorter than UUID)
 * @returns A unique string ID
 */
export function generateId(): string {
  return Math.random().toString(36).substr(2, 9);
}

/**
 * Generate a temporary ID for new items (prefixed with 'temp-')
 * @returns A temporary ID string
 */
export function generateTempId(): string {
  return `temp-${generateUUID()}`;
}

/**
 * Check if an ID is a temporary ID
 * @param id - The ID to check
 * @returns True if the ID is a temporary ID
 */
export function isTempId(id: string): boolean {
  return id.startsWith('temp-');
}

/**
 * Generate a DevNode ID with the DevNode_ prefix
 * @returns A DevNode ID string
 */
export function generateDevNodeId(): string {
  return `DevNode_${generateUUID()}`;
} 